
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedService } from '../Services/shared.service';
@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.css'
})
export class LoaderComponent implements OnInit {

  isLoading: boolean = false;

  constructor(public _svc: SharedService) { }

  ngOnInit() {
    this._svc.isLoader.subscribe((value) => {
      this.isLoading = value;
    });
  }
}
